module.exports = __webpack_public_path__ + "static/media/registerbanner.d3f0a91b.jpg";